import { useEffect } from "react";
import { useRawTable } from "../../hooks";

export default function Module_HealthAnalysisManagement_TableGroup({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
}) {
  const { setTbData, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!apiData) return;

    const monthKey = Array.from({ length: 12 }, (_, i) => `month_${i + 1}`);

    let formatData = [
      {
        project: "營養師諮詢",
        type: "個人健康問題諮詢",
        month_1: null,
        month_2: 2,
        month_3: null,
        month_4: 1,
        month_5: null,
        month_6: null,
        month_7: 2,
        month_8: 1,
        month_9: 1,
        month_10: null,
        month_11: null,
        month_12: null,
      },
      {
        project: "護理師諮詢",
        type: "健康檢查報告異常三級",
        month_1: 1,
        month_2: 1,
        month_3: 4,
        month_4: 5,
        month_5: 11,
        month_6: 24,
        month_7: 10,
        month_8: 8,
        month_9: 5,
        month_10: 3,
        month_11: 7,
        month_12: 1,
        rowSpan_project: 9,
      },
      {
        project: "護理師諮詢",
        type: "健康檢查報告異常四級",
        month_1: 1,
        month_2: 4,
        month_3: 4,
        month_4: 10,
        month_5: 2,
        month_6: 4,
        month_7: null,
        month_8: null,
        month_9: 2,
        month_10: null,
        month_11: 5,
        month_12: 13,
        rowSpan_project: null,
      },
      {
        project: "護理師諮詢",
        type: "新進體格檢查報告",
        month_1: 3,
        month_2: null,
        month_3: 4,
        month_4: 7,
        month_5: 1,
        month_6: 4,
        month_7: 3,
        month_8: 5,
        month_9: 7,
        month_10: 2,
        month_11: 2,
        month_12: 2,
        rowSpan_project: null,
      },
      {
        project: "護理師諮詢",
        type: "過負荷",
        month_1: 1,
        month_2: 7,
        month_3: 1,
        month_4: 2,
        month_5: 3,
        month_6: null,
        month_7: 2,
        month_8: 2,
        month_9: 1,
        month_10: 2,
        month_11: 1,
        month_12: 8,
        rowSpan_project: null,
      },
      {
        project: "護理師諮詢",
        type: "人因工程",
        month_1: 5,
        month_2: 2,
        month_3: null,
        month_4: null,
        month_5: 1,
        month_6: 3,
        month_7: null,
        month_8: 1,
        month_9: 2,
        month_10: 2,
        month_11: 1,
        month_12: 3,
        rowSpan_project: null,
      },
      {
        project: "護理師諮詢",
        type: "個人健康問題諮詢",
        month_1: null,
        month_2: null,
        month_3: 1,
        month_4: 2,
        month_5: null,
        month_6: null,
        month_7: 2,
        month_8: null,
        month_9: 1,
        month_10: 1,
        month_11: 1,
        month_12: 3,
        rowSpan_project: null,
      },
      {
        project: "護理師諮詢",
        type: "復工評估",
        month_1: null,
        month_2: null,
        month_3: 1,
        month_4: null,
        month_5: 1,
        month_6: null,
        month_7: null,
        month_8: null,
        month_9: null,
        month_10: 1,
        month_11: null,
        month_12: null,
        rowSpan_project: null,
      },
      {
        project: "護理師諮詢",
        type: "母性保護健康",
        month_1: null,
        month_2: null,
        month_3: null,
        month_4: null,
        month_5: null,
        month_6: null,
        month_7: null,
        month_8: null,
        month_9: null,
        month_10: null,
        month_11: 1,
        month_12: null,
        rowSpan_project: null,
      },
      {
        project: "護理師諮詢",
        type: "母性健康保護",
        month_1: null,
        month_2: null,
        month_3: 1,
        month_4: null,
        month_5: null,
        month_6: null,
        month_7: null,
        month_8: null,
        month_9: null,
        month_10: null,
        month_11: null,
        month_12: null,
        rowSpan_project: null,
      },
      {
        project: "醫師/護理師諮詢",
        type: "過負荷",
        month_1: null,
        month_2: null,
        month_3: null,
        month_4: null,
        month_5: null,
        month_6: null,
        month_7: null,
        month_8: null,
        month_9: null,
        month_10: null,
        month_11: 2,
        month_12: 3,
        rowSpan_project: 4,
      },
      {
        project: "醫師/護理師諮詢",
        type: "健康檢查報告異常四級",
        month_1: null,
        month_2: null,
        month_3: null,
        month_4: null,
        month_5: null,
        month_6: null,
        month_7: null,
        month_8: null,
        month_9: null,
        month_10: null,
        month_11: 4,
        month_12: null,
        rowSpan_project: null,
      },
      {
        project: "醫師/護理師諮詢",
        type: "人因工程",
        month_1: null,
        month_2: null,
        month_3: null,
        month_4: null,
        month_5: null,
        month_6: null,
        month_7: null,
        month_8: null,
        month_9: null,
        month_10: null,
        month_11: 2,
        month_12: 1,
        rowSpan_project: null,
      },
      {
        project: "醫師/護理師諮詢",
        type: "個人健康問題諮詢",
        month_1: null,
        month_2: null,
        month_3: null,
        month_4: null,
        month_5: null,
        month_6: null,
        month_7: null,
        month_8: null,
        month_9: null,
        month_10: null,
        month_11: null,
        month_12: 1,
        rowSpan_project: null,
      },
    ];

    setTbData({
      raw: formatData,
      format: null,
      export: null,
    });
  }, [apiData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
      })}
    </>
  );
}
